export const useComponentPresetProp = {
  preset: {
    type: String,
    default: undefined,
  },
}
